import { createRouter, createWebHashHistory } from 'vue-router'
import Style from '@/views/StyleView.vue'
import Home from '@/views/HomeView.vue'

const routes = [
  {
    meta: {
      title: 'Home',
      requiresAuth: true
    },
    path: '/',
    name: 'home',
    component: Home
  },
  {
    // Document title tag
    // We combine it with defaultDocumentTitle set in `src/main.js` on router.afterEach hook
    meta: {
      title: 'Dashboard',
      requiresAuth: true
    },
    path: '/dashboard',
    name: 'dashboard',
    component: Home
  },
  {
    meta: {
      title: 'Devices',
      requiresAuth: true
    },
    path: '/devices',
    name: 'devices',
    component: () => import('@/views/DevicesView.vue')
  },
  {
    meta: {
      title: 'DeviceDetail',
      requiresAuth: true
    },
    path: '/devices/:id',
    name: 'device-detail',
    component: () => import('@/views/DeviceDetailView.vue')
  },
  {
    meta: {
      title: 'Styles',
    },
    path: '/styles',
    name: 'styles',
    component: () => import('@/views/StyleView.vue')
  },
  {
    meta: {
      title: 'Profile',
      requiresAuth: true
    },
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/ProfileView.vue')
  },
  {
    meta: {
      title: 'Login'
    },
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
      // if (to.name !== 'Login'
      const currentUser = localStorage.getItem("user");
      if (currentUser) {
          // User is authenticated, proceed to the route
          next();
      } else {
          // User is not authenticated, redirect to login
          // next('/login');
          next({ name: 'login' })
          //return { name: 'Login' }
      }
  } else {
      // Non-protected route, allow access
      next();
  }
});

export default router
